import type { ExtractedRiskItem, RiskSeverity } from '@/types/extraction'

/**
 * Residual where set, inherent otherwise — the number that moves when you mitigate.
 *
 * A risk keeps its inherent `severity` for the record. Once the team writes a
 * mitigation plan and rates what is left, `residualSeverity` is the severity the
 * board should sort, filter and count by.
 */
export function effectiveRiskSeverity(
  item: Pick<ExtractedRiskItem, 'severity' | 'residualSeverity'>
): RiskSeverity {
  return item.residualSeverity ?? item.severity
}
